// ============================================================
// Exit-Intent Popup mit Lead-Magnet-Formular (contact-form AJAX)
// Desktop: Maus verlässt das Fenster nach oben.
// Mobile:  schnelles Hochscrollen ODER Timeout-Fallback.
// Wird nach erfolgreicher Anzeige pro Besucher (localStorage) gemerkt.
// ============================================================

window.addEventListener('DOMContentLoaded', function () {
	const popup = document.querySelector('.js-exit-popup');
	if (!popup) return;

	const form = popup.querySelector('.js-exit-popup-form');
	const formView = popup.querySelector('.js-exit-popup-form-view');
	const thanksView = popup.querySelector('.js-exit-popup-thanks');
	const errorBox = popup.querySelector('.js-exit-popup-error');
	const submitBtn = popup.querySelector('.js-exit-popup-submit');
	const closeEls = popup.querySelectorAll('.js-exit-popup-close');

	const STORAGE_KEY = 'feliciaExitPopupSeen';
	const SUPPRESS_DAYS = 7;          // so lange nach Anzeige nicht erneut zeigen
	const MOBILE_TIMEOUT = 25000;     // Fallback-Trigger auf Mobile (ms)

	const isMobile = window.matchMedia('(max-width: 767px)').matches;
	let shown = false;

	// --- bereits gesehen? ---
	function alreadySeen() {
		try {
			const ts = parseInt(localStorage.getItem(STORAGE_KEY), 10);
			if (!ts) return false;
			return (Date.now() - ts) < SUPPRESS_DAYS * 24 * 60 * 60 * 1000;
		} catch (e) {
			return false;
		}
	}

	function markSeen() {
		try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
	}

	// --- öffnen / schließen ---
	function openPopup() {
		if (shown || alreadySeen()) return;
		// nicht über das geöffnete Kontakt-Popup legen
		if (document.querySelector('.js-contact-popup.is-active')) return;
		shown = true;
		markSeen();
		popup.classList.add('is-active');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('exit-popup-open');
		removeTriggers();
	}

	function closePopup() {
		popup.classList.remove('is-active');
		popup.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('exit-popup-open');
	}

	closeEls.forEach((el) => el.addEventListener('click', closePopup));
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && popup.classList.contains('is-active')) closePopup();
	});

	// --- Trigger-Verwaltung ---
	function onMouseOut(e) {
		// Maus verlässt das Fenster nach oben (Tab schließen / Adressleiste)
		if (e.clientY <= 0 && !e.relatedTarget) openPopup();
	}

	let lastY = window.scrollY;
	let mobileTimer = null;
	function onScroll() {
		const y = window.scrollY;
		// schnelles Hochscrollen im oberen Seitenbereich
		if (lastY - y > 12 && y < 400) openPopup();
		lastY = y;
	}

	function addTriggers() {
		if (alreadySeen()) return;
		if (isMobile) {
			window.addEventListener('scroll', onScroll, { passive: true });
			mobileTimer = setTimeout(openPopup, MOBILE_TIMEOUT);
		} else {
			document.addEventListener('mouseout', onMouseOut);
		}
	}

	function removeTriggers() {
		document.removeEventListener('mouseout', onMouseOut);
		window.removeEventListener('scroll', onScroll);
		if (mobileTimer) clearTimeout(mobileTimer);
	}

	addTriggers();

	// --- AJAX-Submit ---
	if (form) {
		form.addEventListener('submit', async function (e) {
			e.preventDefault();
			if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

			// DSGVO-Checkbox prüfen
			const consent = form.querySelector('input[name="dsgvo"]');
			if (consent && !consent.checked) {
				showError('Bitte stimmen Sie der Datenschutzerklärung zu.');
				return;
			}

			// Spamschutz-Token (Bots ohne JS schicken es leer)
			const token = form.querySelector('input[name="feliciaToken"]');
			if (token) token.value = token.dataset.token || '';

			submitBtn.disabled = true;
			submitBtn.classList.add('is-loading');

			try {
				const res = await fetch(window.location.pathname, {
					method: 'POST',
					headers: {
						'Accept': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: new FormData(form),
				});
				const data = await res.json().catch(() => ({}));

				// Craft (asModelSuccess) gibt bei Erfolg { message } ohne "success" zurück;
				// Fehler liefern { errors: {...} }. Erfolg = ok && keine Fehler.
				if (res.ok && !data.errors) {
					showThanks();
				} else {
					const msg = data.errors
						? Object.values(data.errors).flat().join(' ')
						: (data.message || 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
					showError(msg);
				}
			} catch (err) {
				showError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
			} finally {
				submitBtn.disabled = false;
				submitBtn.classList.remove('is-loading');
			}
		});
	}

	function showError(msg) {
		if (!errorBox) return;
		errorBox.textContent = msg;
		errorBox.hidden = false;
	}

	function showThanks() {
		if (formView) formView.hidden = true;
		if (thanksView) thanksView.hidden = false;
	}
});
